import { render } from "./DynamicBackground.vue?vue&type=template&id=d5758988&scoped=true"
import script from "./DynamicBackground.vue?vue&type=script&lang=js"
export * from "./DynamicBackground.vue?vue&type=script&lang=js"

import "./DynamicBackground.vue?vue&type=style&index=0&id=d5758988&lang=scss&scoped=true"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5758988"]])

export default __exports__